export const CAB_MEETING_STATE_OPTIONS = [
  { value: 'Pending', label: 'Pending' },
  { value: 'Scheduled', label: 'Scheduled' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Cancelled', label: 'Cancelled' },
] as const;

export const CAB_MEETING_DEFAULT_STATE = 'Pending' as const;
